module.exports = __webpack_public_path__ + "img/en-box4-text-dark.2915e962.png";